import { render, staticRenderFns } from "./TestimonialCard.vue?vue&type=template&id=430a8f41&scoped=true&"
import script from "./TestimonialCard.vue?vue&type=script&lang=ts&"
export * from "./TestimonialCard.vue?vue&type=script&lang=ts&"
import style0 from "./TestimonialCard.vue?vue&type=style&index=0&id=430a8f41&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430a8f41",
  null
  
)

export default component.exports